import barba from '@barba/core';


const init = async () => {

const hasBarbaWrapper = document.querySelector('[data-barba="container"]');

if (hasBarbaWrapper) {
barba.init ({
	//debug: true,
  timeout: 7000,
	sync: false,
	preventRunning: true,
	prevent: ({ el, event }) =>  {
        if (event.type === 'click') {
            if(el.classList && (el.classList.contains('ab-item'))) {
                return true;
            }
            if(el.classList && (el.classList.contains('prevent'))) {
                return true;
            }
            if(el.classList && (el.classList.contains('wp-block-button__link'))) {
                return true;
            }
          // prevent the user to reload the page if the location is the same
          if (el.href === window.location.href) {
            event.preventDefault();
            event.stopPropagation();
            return true;
          }
        }
      },
    transitions: [
      {
        name: 'default-transition',
        async leave(data) {
         await trans_default__page_out(data);
        },
        async enter(data) {
            await trans_default__page_in(data);
        }
      }
    ]  
  }); 

};
}

function trans_default__page_out() {
  //console.log('out');
  curtainDrop();
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, 500);
  }); 
}

function trans_default__page_in() {
  return new Promise(resolve => {
    setTimeout(() => {
      curtainPull();
      resolve();
    }, 200);
  });
}

function curtainDrop() {
  const curtain = document.querySelector('.loader');
  if (curtain) curtain.classList.add('drop');
}

export function curtainPull() {
  const curtain = document.querySelector('.loader');
  if (curtain) curtain.classList.remove('drop'); 
}

export { init };